/**
 * Body typography components
 *
 * @example
 * ```tsx
 * <BodyM>Regular body text</BodyM>
 * <BodyMSemiBold color="secondary">Bold body text</BodyMSemiBold>
 * ```
 */

import { TYPOGRAPHY_VARIANTS } from './config';
import { createTypographyComponent } from './Factory';

/**
 * BodyXL - Extra large body text (18px)
 */
export const BodyXL = createTypographyComponent(
	'BodyXL',
	TYPOGRAPHY_VARIANTS.BodyXL
);

/**
 * BodyL - Large body text (16px)
 */
export const BodyL = createTypographyComponent(
	'BodyL',
	TYPOGRAPHY_VARIANTS.BodyL
);

/**
 * BodyM - Medium body text (14px, regular weight)
 */
export const BodyM = createTypographyComponent(
	'BodyM',
	TYPOGRAPHY_VARIANTS.BodyM
);

/**
 * BodyMSemiBold - Medium body text (14px, semi-bold weight)
 */
export const BodyMSemiBold = createTypographyComponent(
	'BodyMSemiBold',
	TYPOGRAPHY_VARIANTS.BodyMSemiBold
);

/**
 * BodyS - Small body text (12px, regular weight)
 */
export const BodyS = createTypographyComponent(
	'BodyS',
	TYPOGRAPHY_VARIANTS.BodyS
);

/**
 * BodySSemiBold - Small body text (12px, semi-bold weight)
 */
export const BodySSemiBold = createTypographyComponent(
	'BodySSemiBold',
	TYPOGRAPHY_VARIANTS.BodySSemiBold
);

/**
 * BodyXS - Extra small body text (11px, regular weight)
 */
export const BodyXS = createTypographyComponent(
	'BodyXS',
	TYPOGRAPHY_VARIANTS.BodyXS
);

/**
 * BodyXSSemiBold - Extra small body text (11px, semi-bold weight)
 */
export const BodyXSSemiBold = createTypographyComponent(
	'BodyXSSemiBold',
	TYPOGRAPHY_VARIANTS.BodyXSSemiBold
);
